const Insurance = function (data) {
  if (!data) data = {};
  this.InsuranceCarrier = data.InsuranceCarrier || null;
  this.PolicyNumber = data.PolicyNumber || null;
  this.InsuranceExpirationDate = data.InsuranceExpirationDate || null;
  this.InsuranceVerified = data.InsuranceVerified || null;
};
export default Insurance;
